// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__DmcBD","col":"styles_col__37Eff"};